RivalIQ.apps.SocialPosts.module('widgets', function (widgets, App, Backbone, Marionette, $, _) {

    'use strict';

    const Dashboard = RivalIQ.apps.Dashboard;

    const Table = Dashboard.widgets.SummarizedMetricTable.mixin({
        mixins: {
            postAggregatesTableRowClickMixin: widgets.PostAggregatesTableRowClickMixin,
            PostTagsReload: App.mixins.PostTagsReload,
            companySetChangeReload: RivalIQ.apps.Shell.mixins.CompanySetChangeReload
        },

        className: function () {
            const me = this;
            const className = Dashboard.widgets.SummarizedMetricTable.prototype.className.apply(me, arguments);
            return [className, 'boosted-posts-table'].join(' ');
        },
        getFetchAttributes: function () {
            const me = this;
            const attributes = Dashboard.widgets.SummarizedMetricTable.prototype.getFetchAttributes.apply(me, arguments);
            return _.pick(attributes, 'limit');
        }
    });

    const BoostedPosts = Dashboard.widgets.SummarizedTableWidget.extend({
        view: Table,
        title: RivalIQ.strings.social_post_boosted_posts_title,
        description: RivalIQ.strings.social_post_boosted_posts_description,
        viewMorePath: function () {
            const me = this;
            const props = _.defaults({
                limit: -1,
                instanceId: 'boosted-posts'
            }, _.pick(me.getProps(), App.utils.validCurationOptions));
            const route = Dashboard.router.router.resolveCurationRoute(me.curation.id, props);
            return route;
        },
        filter: function () {
            const me = this;
            const plan = me.getProp('plan');
            const channel = RivalIQ.data.channels.get(me.getProp('channel'));
            const hasLikelyPromoted = _.get(plan, 'has_likely_promoted', false);
            return (channel.get('channel') !== RivalIQ.enums.channels.FACEBOOK || !hasLikelyPromoted);
        },
        getBaseMetric: function () {
            return new RivalIQ.models.MetricDefinition({
                concept: RivalIQ.metrics.descriptions.SOCIAL_POSTS.id,
                dimensions: ['companyId']
            });
        },
        processProps: function (props) {
            const me = this;

            _.defaults(props, {
                filter: false,
                showDescriptions: true,
                sortable: (props.limit === -1),
                sortOrder: 1,
                metrics: [
                    {
                        property: 'name',
                        sortable: false
                    },
                    {
                        description: RivalIQ.strings.facebook_posts_likely_boosted_description,
                        property: 'count_likely_boosted'
                    },
                    {
                        description: RivalIQ.strings.facebook_posts_non_boosted_description,
                        property: 'count_non_boosted'
                    },
                    {
                        description: RivalIQ.strings.facebook_average_likely_boosted_post_engagement_rate_description,
                        property: 'avg_engagement_rate_per_boosted_post'
                    },
                    {
                        description: RivalIQ.strings.facebook_average_non_boosted_post_engagement_rate_description,
                        property: 'avg_engagement_rate_per_non_boosted_post'
                    }
                ]
            });

            if (!me.metric) {
                me.metric = me.getBaseMetric();
            }

            App.utils.updateMetric(me.metric, props);

            me.metricsCollection = props.metrics;
            RivalIQ.models.MetricDefinition.build(me, me.metric, {}, 'metricsCollection');

            me.summaryMetrics = me.getSummaryMetrics(props);

            return props;
        },
        getSummaryMetrics: function (props) {
            const metric = RivalIQ.metric.build(props, {
                // NOTE we don't care about `orderBy` for summary metrics, and
                // to leave it as is can cause server errors on requests
                orderBy: undefined,
                concept: RivalIQ.metrics.descriptions.SOCIAL_POSTS.id,
                dimensions: ['companyId']
            });

            const focusMetric = RivalIQ.metric.build(metric, {
                companyId: props.focusCompanyId
            });

            const landscapeAverageMetric = RivalIQ.metric.build(metric, {
                // NOTE for metrics that define an `aggregate` the `format`
                // property has a special behavior that will cause it to return
                // the export format literal (e.g., `png`) if left in attributes
                format: undefined,
                name: 'Landscape Avg.',
                aggregate: 'average',
                over: ['companyId']
            });

            const audienceName = props.channel === 'facebook' ? 'Page Fan' : 'Follower';

            const metrics = [
                {
                    metrics: [
                        RivalIQ.metric.build(focusMetric, {
                            name: 'Your Likely Boosted Posts',
                            description: RivalIQ.strings.facebook_posts_likely_boosted_description,
                            property: 'count_likely_boosted'
                        }),
                        RivalIQ.metric.build(landscapeAverageMetric, {
                            property: 'count_likely_boosted'
                        })
                    ]
                },
                {
                    metrics: [
                        RivalIQ.metric.build(focusMetric, {
                            name: 'Your Likely Organic Posts',
                            description: RivalIQ.strings.facebook_posts_non_boosted_description,
                            property: 'count_non_boosted'
                        }),
                        RivalIQ.metric.build(landscapeAverageMetric, {
                            property: 'count_non_boosted'
                        })
                    ]
                },
                {
                    metrics: [
                        RivalIQ.metric.build(focusMetric, {
                            name: `Your Eng. Rate by ${audienceName}, Likely Boosted`,
                            abbreviatedName: 'Your Eng. Rate, Likely Boosted',
                            description: RivalIQ.strings.facebook_average_likely_boosted_post_engagement_rate_description,
                            property: 'engagement_total_likely_boosted / presence_reach_likely_boosted'
                        }),
                        RivalIQ.metric.build(landscapeAverageMetric, {
                            property: 'avg_engagement_rate_per_boosted_post'
                        })
                    ]
                },
                {
                    metrics: [
                        RivalIQ.metric.build(focusMetric, {
                            name: `Your Eng. Rate by ${audienceName}, Likely Organic`,
                            abbreviatedName: 'Your Eng. Rate, Likely Organic',
                            description: RivalIQ.strings.facebook_average_non_boosted_post_engagement_rate_description,
                            property: 'engagement_total_non_boosted / presence_reach_non_boosted'
                        }),
                        RivalIQ.metric.build(landscapeAverageMetric, {
                            property: 'avg_engagement_rate_per_non_boosted_post'
                        })
                    ]
                }
            ];

            return new Backbone.Collection(metrics);
        }
    });

    Marionette.Dashboard.widgets.add(RivalIQ.enums.widgetTypes.SOCIAL_POSTS_BOOSTED_POSTS_TABLE, BoostedPosts);

});
